const caseTabs = {
    normal: 'normal',
    replying: 'replying',
    forwarding: 'forwarding'
}

export default caseTabs